export const SHOW_ISLE_OF_MAN = process.env.REACT_APP_SHOW_ISLE_OF_MAN === 'true';

// While this is off every volume is a public download: take the paid files out of public/ before turning it on.
export const SHOW_PAYMENTS = process.env.REACT_APP_EDUCATION_PAYMENTS === 'true';
